import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Message} from '../models/message';
import 'rxjs/add/operator/map';

@Injectable()
export class WalletService {

  private url = `${ environment.apiRoot }/user-wallet/`;
  private urlcheck = `${ environment.apiRoot }/user-check/`;
  constructor(private http: HttpAuth) { }

  public send(jobId: string, message: Message, userId?: string): Observable<any> {
    const params = { job_id: jobId, title: message.subject, content: message.description };
    if (userId) {
        params['user_id'] = userId;
    }

    if (status) {
        params['status'] = status;
    }

    const body = JSON.stringify(params);

    return this.http.post(this.url, body)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getWallets(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getUsercheck(user_id: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

      params.append('user_id', user_id);


    const options = new RequestOptions({search: params});

    return this.http.get(this.urlcheck, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postUsercheck(id: number, place: string, status: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const data = {
      'place' : place,
      'status' : String(status),
      'id' : String(id)
    };
    const options = new RequestOptions({search: params});

    return this.http.post(this.urlcheck, data, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/wallet.service.ts